import React, { FC } from 'react';

import Columns, {
  SubscriptionButtonTitle,
} from '@/components/Subscription/PlanTable/Columns';
import HeaderColumn from '@/components/Subscription/PlanTable/headerColumn';
import ResponsiveTable from '@/components/Subscription/PlanTable/ResponsiveTable';
import SingleColumn from '@/components/Subscription/PlanTable/SingleColumn';

import { IPlan } from '@/utils/interfaces/Subscription';

export const headerHeight = 372;
export const whatInsideHeight = 76;
export const whatYouWillGetHeight = 48;
export const cellHeight = 56;
export const typeMarginLeft = 12;
export const planHeaderHeight = 40;
export const borderColorClassName = 'border-grayZl-800';
export const borderClassName = 'border';
export const borderR = 'border-r';
export const borderL = 'border-l';
export const borderT = 'border-t';
export const borderB = 'border-b';
export const headerClass = 'xl:text-base text-sm text-white font-normal mx-4';
export const PlanHeaderTitleClass =
  'text-primary text-sm leading-[22px] font-semibold';

interface Props {
  plans: IPlan[] | undefined;
  setSelectedPlan: React.Dispatch<React.SetStateAction<IPlan | undefined>>;
  subscriptionHandle: (buttonTitle: SubscriptionButtonTitle) => Promise<void>;
}
const PlanTable: FC<Props> = ({
  plans,
  setSelectedPlan,
  subscriptionHandle,
}) => {
  return (
    <div>
      <div className=' md:flex hidden lg:mx-0 md:mx-0 relative mt-0 mb-16 px-6'>
        <HeaderColumn />
        <SingleColumn
          subscriptionHandle={subscriptionHandle}
          setSelectedPlan={setSelectedPlan}
          plans={plans}
        />

        <div className='flex items-center justify-center'>
          <div className='h-10 w-1 rounded-full bg-white mx-3' />
        </div>
        <Columns
          subscriptionHandle={subscriptionHandle}
          setSelectedPlan={setSelectedPlan}
          plans={plans}
        />
      </div>
      <div className='block md:hidden'>
        <ResponsiveTable
          subscriptionHandle={subscriptionHandle}
          setSelectedPlan={setSelectedPlan}
          plans={plans}
        />
      </div>
    </div>
  );
};

export default PlanTable;
